module.exports = __webpack_public_path__ + "static/media/text.49dc13ae.svg";